'use strict';
$(document).ready(function () {
    /**
     * MagicZoom is only initialised after the PDP main image has been loaded by lazysizes.
     * This has been done for performance improvement
     */
    document.addEventListener('lazyloaded', function (e) {
        if ($(e.target).hasClass('pdp-main-image')) {
            // Setting a slight time delay as sometimes there are issues with MagicZoom not getting intialised
            setTimeout(function () {
                MagicZoom.start(); //eslint-disable-line
            }, 1000);
        }
    });
});
